import { DatePicker } from 'antd';
import clsx from 'clsx';
import * as eva from 'eva-icons';
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import React, { useEffect, useState } from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS, DEFAULTDATEFORMAT } from '../../common/constants';
import IndividualReport from './IndividualReport';
import ProjectReport from './ProjectReport';

const MyDatePicker = DatePicker.generatePicker(momentGenerateConfig);
const { RangePicker } = MyDatePicker;
const CustomRangePicker = ({
  id,
  setDateSelected,
  setFromDate,
  setToDate,
  className,
}) => {
  const disabledDate = (current) => {
    // Can not select future date
    return current && current > moment()?.endOf('day');
  };
  return (
    <RangePicker
      id={id}
      className={clsx('custom-date-picker', className)}
      disabledDate={disabledDate}
      separator="-"
      suffixIcon={<i data-eva="calendar-outline" id="date-picker-icon" />}
      format={DEFAULTDATEFORMAT}
      classNames={{ popup: { root: 'custom-date-picker-panel' } }}
      renderExtraFooter={() => (
        <div className="text-danger" id="date-picker-footer">
          All data is based on Greenwich Mean Time (GMT)
        </div>
      )}
      placeholder={['Start Date', 'End Date']}
      defaultValue={[moment().startOf('month'), moment()]}
      presets={[
        {
          label: 'Yesterday',
          value: [moment().subtract(1, 'days'), moment()],
        },
        {
          label: 'Last 8 Days',
          value: [moment().subtract(7, 'days'), moment()],
        },
        {
          label: 'Last 31 Days',
          value: [moment().subtract(30, 'days'), moment()],
        },
        {
          label: 'Last 3 Months',
          value: [moment().subtract(3, 'months'), moment()],
        },
      ]}
      onChange={(e, dates) => {
        if (e) {
          setDateSelected(true);
        } else {
          setDateSelected(false);
        }
        setFromDate(dates[0]);
        setToDate(dates[1]);
      }}
    />
  );
};
const Reports = () => {
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);

  const [dateSelected, setDateSelected] = useState(true);
  const [fromDate, setFromDate] = useState(
    moment().startOf('month').format(DEFAULTDATEFORMAT),
  );
  const [toDate, setToDate] = useState(moment().format(DEFAULTDATEFORMAT));
  useEffect(() => {
    eva.replace();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="reports" id="reports-container">
        {!isDesktopViewport && (
          <div
            className="profile-header d-flex justify-between"
            id="mobile-reports-header"
          >
            <div
              className="page-header text-primary mr-10"
              id="mobile-reports-title"
            >
              Reports
            </div>
            <CustomRangePicker
              id="mobile-date-picker"
              className="blinking-border"
              setDateSelected={setDateSelected}
              setFromDate={setFromDate}
              setToDate={setToDate}
            />
          </div>
        )}
        {isDesktopViewport && (
          <>
            <div
              className="reports-header d-flex align-center justify-between"
              id="desktop-reports-header"
            >
              <div
                className="d-flex align-center"
                id="desktop-reports-title-container"
              >
                <i data-eva="file-text-outline" id="reports-icon" />
                <h1 id="desktop-reports-title">Reports</h1>
              </div>
              <CustomRangePicker
                id="desktop-date-picker"
                className="blinking-border"
                setDateSelected={setDateSelected}
                setFromDate={setFromDate}
                setToDate={setToDate}
              />
            </div>
          </>
        )}

        <div className="reports-content" id="reports-content">
          <ProjectReport
            id="project-report"
            dateSelected={dateSelected}
            fromDate={fromDate}
            toDate={toDate}
          />
          <IndividualReport
            id="individual-report"
            dateSelected={dateSelected}
            fromDate={fromDate}
            toDate={toDate}
          />
        </div>
      </div>
    </>
  );
};

export default Reports;
